import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule } from '@ionic/angular';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CoreModule, MiscModule } from '@smartdirect/core';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule.forRoot({
      adminPortal: environment.adminPortal,
      apiKeys: environment.apiKeys,
      colors: environment.colors,
      container: environment.container,
      loggerHostname: environment.loggerHostname,
      production: environment.production,
      propertyForce: environment.propertyForce,
      report: environment.report,
      tutorialsUrl: environment.tutorialsUrl
    }),
    !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
    IonicModule,
    MiscModule
  ],
  providers: []
})
export class AppModule {}
